import React from 'react'
import { useStateValue } from '@State'

export function CompleteBadgeImage() {
  const [state, dispatch] = useStateValue()

  const handleChange = newImage => {
    let newName = newImage.name
    let reader = new FileReader()
    reader.readAsDataURL(newImage)
    reader.onload = e => {
      dispatch({
        type: 'UPDATE_BADGE_INFO',
        badgeInfo: {
          completeImage: e.target.result,
          completeImageName: newName,
          completeImageLoaded: true,
          completeNewUploadedImage: true,
        },
      })
    }
  }

  return (
    <div className="image_info">
      <input
        type="file"
        id="image_input"
        accept=".png, .jpeg, .jpg"
        onChange={e => handleChange(e.target.files[0])}
      />
      <p>{state.badgeInfo.completeImageName ? state.badgeInfo.completeImageName : ''}</p>
    </div>
  )
}
